import { useEffect, useState } from "react";
import api from "./api";

// Module-level cache so login → setup → superadmin-login all hit the same branding
// state during a single page lifecycle.
let _cache = null;
let _fetched = false;

const DEFAULTS = {
  heading_line_1: "A practical CRM",
  heading_line_2: "without the bloat.",
  tagline: "No unnecessary features, no steep learning curve. A CRM built the way it should be.",
  footer_text: "v1.0 · PRACTICAL / CLEAN / NO BLOAT",
  logo_data_url: null,
  dashboard_welcome_line_1: "{greeting} {first_name} 👋",
  dashboard_welcome_line_2: "It's time to make your move…",
  dashboard_welcome_line_3: "what would you like to begin with?",
};

export function useBranding() {
  const [branding, setBranding] = useState(_cache || DEFAULTS);

  useEffect(() => {
    if (_fetched) return;
    _fetched = true;
    api.get("/platform/branding")
      .then((r) => { _cache = r.data; setBranding(r.data); })
      .catch(() => {});
  }, []);

  return branding;
}

export function invalidateBrandingCache() {
  _cache = null;
  _fetched = false;
}
